import { useTranslation } from "react-i18next";
import DataTable from "components/datatable/Datatable";
import { RefreshIcon } from "@shopify/polaris-icons";
import { useDispatch } from "react-redux";
import {
  setModalxComponent,
  setModalxComponentProps,
} from "components/modalx/modalx.slice";
import { Column } from "types/Datatable";

type Props = {
  emails: any;
};

const Emails = ({ emails }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleEditClick = async (id: string) => {
    dispatch(setModalxComponent("ResendEmailConfirm"));
    dispatch(
      setModalxComponentProps({
        id,
      })
    );
  };

  // Define base columns
  const columns: Column[] = [
    { key: "#" },
    { key: "emailTo", name: t("email_to") },
    { key: "subject", name: t("email_subject") },
    { key: "sentAt", type: "datetime", name: t("date") },
    {
      key: "email_resend",
      type: "actionBtn",
      name: t("resend"),
      onClick: (item: any) => handleEditClick(item.id),
      Icon: RefreshIcon,
    },
  ];

  return <DataTable collection={emails} columns={columns} />;
};

export default Emails;
